/**
 * アクティビスト
 */
import 'es6-promise/auto';
import 'picturefill';
import { breakpoint, containerID } from '@/_modules/utils/variables';
import {gsap, Cubic} from 'gsap/all';
import Vue from 'vue';
import store from '@/_modules/stores';
import Loading from '@/_components/loading.vue';
import GlobalHeader from '@/_components/global-header.vue';
import GlobalNavi from '@/_components/global-navi.vue';
import InterviewList from '@/_components/interview-list.vue';
import ActivistsList from '@/_components/activists-list.vue';
import Pagetop from '@/_components/pagetop.vue';
import CommonPlugin from '@/_modules/common/common-plugin'
Vue.use(CommonPlugin);

export default class AppActivists {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'AppActivists';
    this.init();
  }

  /**
   * 初期
   */
  init() {
    this.vue = new Vue({
      components: {
        Loading,
        GlobalHeader,
        GlobalNavi,
        InterviewList,
        ActivistsList,
        Pagetop
      },
      data() {
        return {
          ispc: false,
          isLoaded: false,
          isState: '',
          isFinishMore: false,
          titles: []
        }
      },
      el: `#${containerID}`,
      store,
      computed: {
      },
      created() {
        this.$store.commit('setOS');
      },
      mounted() {
        this.$nextTick(this.start);
      },
      methods: {
        start() {
          this.setting();
          this.resize();
          window.addEventListener('resize', this.resize);
          window.addEventListener('scroll', this.scroll);
        },
        setting() {
          const els = document.querySelectorAll('.js-title');
          els.forEach((el, i) => {
            this.titles.push({
              el: el,
              top: this.$_getOffsetTop(el).top,
              isShow: false
            });
          });
        },
        resize() {
          this.titles.forEach((o, i) => {
            if (o.isShow) return true;
            o.top = this.$_getOffsetTop(o.el).top;
          });

          this.scroll();
        },
        scroll() {
          const sY = this.$_currentScrollY() + (window.innerHeight * 0.8);
          this.titles.forEach((item, i) => {
            if (item.isShow) return true;
            if (item.top < sY) {
              item.isShow = true;
              item.el.className = item.el.className + ' isShow';
            }
          });
        },
        showLoading() {
          this.$store.commit('setShowLoading', true);
        },
        hideLoading() {
          this.$store.commit('setShowLoading', false);
        },
        moreInterview() {
          if (this.isFinishMore) return;
          this.$refs['interviewList'].more();
        },
        finishMore() {
          this.isFinishMore = true;
        }
      }
    });
  }
}
